export * from './institutional-documents.js';
export * from './institutional-register.js';
export * from './institutional-concepts.js';
export * from './entity-foundation.js';
export * from './organizations-admin.js';
export { dmExceptionKinds, isDmExceptionsResponse, } from './dm-exceptions.js';
export { isDmStagingResponse, isStageDmResponse, } from './dm-staging.js';
export { adminUserStatuses, isAdminUserDetailResponse, isAdminUserSummary, isAdminUsersListResponse, } from './admin-users.js';
export { isMemberImportReconciliationResponse, isMemberImportResolutionResponse, } from './member-import-reconciliation.js';
export { isMemberImportDiagnosticResponse, } from './member-import-diagnostic.js';
export { isMemberImportMappingResponse, } from './member-import-mapping.js';
export { isMemberImportPreviewResponse, } from './member-import-preview.js';
export { isMemberImportSimulationResponse, } from './member-import-simulation.js';
export { isMemberImportExecutionResponse, } from './member-import-execution.js';
export const URBANIK_TIMEZONE = 'America/Guayaquil';
export function isHealthResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const c = value;
    return ((c.status === 'ok' || c.status === 'degraded') &&
        c.api?.status === 'up' &&
        (c.database?.status === 'up' || c.database?.status === 'down') &&
        typeof c.version === 'string' &&
        typeof c.serverTime === 'string' &&
        c.timezone === URBANIK_TIMEZONE);
}
export function isRolesListResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const roles = value.roles;
    return (Array.isArray(roles) &&
        roles.every((role) => {
            if (typeof role !== 'object' || role === null)
                return false;
            const i = role;
            return (typeof i.id === 'string' &&
                typeof i.code === 'string' &&
                typeof i.name === 'string' &&
                typeof i.description === 'string' &&
                typeof i.isSystem === 'boolean' &&
                Number.isInteger(i.userCount) &&
                Number.isInteger(i.permissionCount));
        }));
}
export function isLoginSuccessResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    const principal = item.principal;
    return (item.authenticated === true &&
        typeof principal?.id === 'string' &&
        typeof principal.email === 'string' &&
        typeof principal.displayName === 'string' &&
        (item.passwordChangeRequired === undefined || typeof item.passwordChangeRequired === 'boolean'));
}
export function isLoginProblem(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return ((item.statusCode === 401 || item.statusCode === 423) &&
        (item.code === 'INVALID_CREDENTIALS' || item.code === 'LOGIN_TEMPORARILY_LOCKED') &&
        typeof item.message === 'string' &&
        (item.retryAfterSeconds === undefined || Number.isInteger(item.retryAfterSeconds)));
}
export function isSessionResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const s = value;
    return (s.authenticated === true &&
        typeof s.expiresAt === 'string' &&
        typeof s.principal?.id === 'string' &&
        typeof s.principal.email === 'string' &&
        typeof s.passwordChangeRequired === 'boolean' &&
        typeof s.principal.displayName === 'string');
}
export function isPermissionMatrixResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const roles = value.roles;
    return (Array.isArray(roles) &&
        roles.every((r) => {
            if (typeof r !== 'object' || r === null)
                return false;
            const x = r;
            return (typeof x.roleId === 'string' &&
                typeof x.roleCode === 'string' &&
                typeof x.roleName === 'string' &&
                Number.isInteger(x.userCount) &&
                Array.isArray(x.permissions) &&
                x.permissions.every((p) => typeof p === 'string'));
        }));
}
export function isAccessContextResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const access = value;
    return (access.authenticated === true &&
        typeof access.expiresAt === 'string' &&
        typeof access.principal?.id === 'string' &&
        typeof access.principal.email === 'string' &&
        typeof access.principal.displayName === 'string' &&
        Array.isArray(access.roles) &&
        access.roles.every((role) => typeof role === 'string') &&
        Array.isArray(access.permissions) &&
        access.permissions.every((permission) => typeof permission === 'string'));
}
export const memberStatuses = ['active', 'inactive'];
const isIso8601 = (value) => typeof value === 'string' && !Number.isNaN(Date.parse(value));
export function isMemberTechnicalExplorerResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const response = value;
    if (response.timezone !== URBANIK_TIMEZONE)
        return false;
    if (response.member === null)
        return true;
    const m = response.member;
    return (typeof m?.id === 'string' &&
        typeof m.nationalId === 'string' &&
        /^\d{6,20}$/.test(m.nationalId) &&
        typeof m.givenNames === 'string' &&
        typeof m.familyNames === 'string' &&
        (m.email === null || typeof m.email === 'string') &&
        (m.primaryPhone === null || typeof m.primaryPhone === 'string') &&
        (m.secondaryPhone === null || typeof m.secondaryPhone === 'string') &&
        memberStatuses.includes(m.status) &&
        Number.isInteger(m.version) &&
        m.version > 0 &&
        isIso8601(m.createdAt) &&
        isIso8601(m.updatedAt) &&
        Array.isArray(m.history) &&
        m.history.length > 0 &&
        m.history.every((h, i) => typeof h.id === 'string' &&
            memberStatuses.includes(h.status) &&
            typeof h.reason === 'string' &&
            isIso8601(h.occurredAt) &&
            Number.isInteger(h.sequence) &&
            h.sequence === i + 1));
}
export { memberListSorts, isMembersListResponse, } from './members-list.js';
export { isCreateMemberResponse, } from './member-create.js';
export { isMemberDetailResponse, } from './member-detail.js';
export { isActContract, isActDetailResponse, isActsListResponse, actOrgans, actSessionTypes, } from './professional-acts.js';
export { actAiExtractionSchema, isActAiExtractionResponse, } from './act-ai-extraction.js';
export { isHouseholdMemberPhotoResponse, } from './household-member-photo.js';
export { isAdminMemberProfileResponse, isMemberProfileCatalogsResponse, } from './admin-member-profile.js';
export { isMemberUpdateAuthorizationsResponse, isMemberUpdateCapabilitiesResponse, } from './member-update-authorization.js';
export { isMemberPhotoResponse, } from './member-photo.js';
export { isMemberAddressLocationResponse, } from './member-address-location.js';
export { isHouseholdCatalogsResponse, isMemberHouseholdsResponse, } from './member-household.js';
export { isConcept, isConceptResponse, isConceptsResponse, } from './concepts.js';
export { isRuleSimulationResponse, } from './rule-simulation.js';
export { isFixedRule, isFixedRuleResponse, isFixedRulesResponse, isFixedRuleVersionsResponse, rulePeriodicities, } from './fixed-rules.js';
export { isUserRoleAssignmentResponse, } from './user-roles.js';
export { isRoleCatalogDetailResponse, isRoleCatalogItem, isRoleCatalogListResponse, } from './role-catalog.js';
export { isRolePermissionResponse, } from './role-permissions.js';
export { isInitialCredentialResponse, } from './initial-credentials.js';
export { isObligationModelContract } from './obligation-model.js';
export { isCreateIndividualObligationResponse, } from './individual-obligations.js';
export { isObligationBatchPreviewResponse, } from './obligation-batch-preview.js';
export { isConfirmObligationBatchResponse, } from './obligation-batch-confirmation.js';
export { isObligationPortfolioResponse, } from './obligation-portfolio.js';
export { URBANIK_RELEASE } from './release-info.js';
